import LOGO_MAREUIL from "../assets/images/LOGO_MAREUIL.jpg";
import LOGO_ROCHE from "../assets/images/LOGO_ROCHE.jpg";
import LOGO_SABLES from "../assets/images/LOGO_SABLES.jpg";

export const couleurZaDeploiement = {
  ZONE_RADIO: "#D371C7",
  ZASROCommercialisable20182020: "#B9E239",
  ZASROCommercialisable2021: "#00BA96",
  ZASROCommercialisable2022: "#FFC533",
  ZASROCommercialisable2023: "#FF5533",
  ZaSroOpen: "#0DC54E",
  ZaSroSoon: "#FFAD05",
  ZaSroYearNX: "#6487FB",
  ZaSroYearN0: "#6487FB",
  ZaSroYearN1: "#FF7A90",
  ZaSroYearN2: "#4AFFED",
  ZAAMII: "#CCCCCC",
};

export const colorIcons = {
  raccorde: "#008000",
  deploye: "#89C54E",
  prochainementEligible: "#06A6FF",
  gelCommercial: "#BA55D3",
  cible: "#999999",
  demande: "#F98410",
  gelVendee: "#E6B800",
  travauxRueVendee: "#FB8245",
  travauxSecteurVendee: "#FB4343",
  cibleVendee: "#4343FB",
  demandeVendee: "#AAAAAA",
  blocCollectifTiers: "#FF0000",
};

export const dspList = [
  {
    logo: "images/dsp/CRS00.png",
    codeMarche: "CRS00",
    codeReseau: "AI-OCTO",
    libelle: "Octogone Fibre",
    urlSite: "https://www.octogone-fibre.fr/",
    urlZonesDeploiement: "https://www.octogone-fibre.fr/le-projet-tres-haut-debit/deploiement/",
    urlFibreFtth: "https://www.octogone-fibre.fr/pourquoi-je-ne-suis-pas-eligible-a-la-fibre/",
    urlFibreSurDemande:
      "https://www.octogone-fibre.fr/pourquoi-je-ne-suis-pas-eligible-a-la-fibre/",
    urlFibreFtte: "https://www.octogone-fibre.fr/la-fibre-pour-les-entreprises/",
    urlChangementAdresse: "https://renseignementsfibre.altitudeinfra.fr/eligibilite/dsp/CRS00",
    urlListeOperateur:
      "https://www.octogone-fibre.fr/operateurs-sur-le-reseau-octogone-fibre-by-altitude-infra/",
    urlPreparation:
      "https://www.octogone-fibre.fr/wp-content/uploads/sites/14/2022/02/checklist-octogone-rv.pdf",
    secondaryMarches: [],
  },
  {
    logo: "images/dsp/CLP00.png",
    codeMarche: "CLP00",
    codeReseau: "AI-JURA",
    libelle: "PRISME",
    urlSite: "https://www.prisme-fibre.fr/",
    urlZonesDeploiement: "https://www.prisme-fibre.fr/le-projet-tres-haut-debit/deploiement/",
    urlFibreFtth: "https://www.prisme-fibre.fr/pourquoi-je-ne-suis-pas-eligible-a-la-fibre/",
    urlFibreSurDemande: "https://www.prisme-fibre.fr/pourquoi-je-ne-suis-pas-eligible-a-la-fibre/",
    urlFibreFtte: "https://www.prisme-fibre.fr/la-fibre-pour-les-entreprises/", // ??
    urlChangementAdresse: "https://renseignementsfibre.altitudeinfra.fr/eligibilite/dsp/CLP00",
    urlListeOperateur: "https://www.prisme-fibre.fr/operateurs/",
    urlPreparation:
      "https://www.prisme-fibre.fr/wp-content/uploads/sites/14/2022/02/checklist-octogone-rv.pdf",
    maxYear: 2024,
    secondaryMarches: [],
  },
  {
    logo: "images/dsp/MFI00.png",
    codeMarche: "MFI00",
    codeReseau: "AI-MNUM",
    libelle: "MANCHE FIBRE",
    urlSite: "https://www.manche-fibre.fr/",
    urlZonesDeploiement:
      "https://www.manche-fibre.fr/le-projet-tres-haut-debit/operateurs/deploiement/",
    urlFibreFtth: "https://www.manche-fibre.fr/pourquoi-je-ne-suis-pas-eligible-a-la-fibre/",
    urlFibreSurDemande: "https://www.manche-fibre.fr/pourquoi-je-ne-suis-pas-eligible-a-la-fibre/",
    urlFibreFtte: "https://www.manche-fibre.fr/la-fibre-pour-les-entreprises/", // ??
    urlChangementAdresse: "https://renseignementsfibre.altitudeinfra.fr/eligibilite/dsp/MFI00",
    urlListeOperateur: "https://www.manche-fibre.fr/le-projet-tres-haut-debit/operateurs/",
    urlPreparation:
      "https://www.manche-fibre.fr/wp-content/uploads/sites/13/2022/11/Checklist-raccordement.pdf",
    secondaryMarches: [],
  },
  {
    logo: "images/dsp/TLA00.png",
    codeMarche: "TLA00",
    codeReseau: "AI-FI31",
    libelle: "FIBRE 31",
    urlSite: "https://www.fibre31.fr/",
    urlZonesDeploiement: "https://www.fibre31.fr/le-projet-tres-haut-debit/deploiement/",
    urlFibreFtth: "https://www.fibre31.fr/pourquoi-je-ne-suis-pas-eligible-a-la-fibre/",
    urlFibreSurDemande: "https://www.fibre31.fr/pourquoi-je-ne-suis-pas-eligible-a-la-fibre/",
    urlFibreFtte: "https://www.fibre31.fr/la-fibre-pour-les-entreprises/",
    urlChangementAdresse: "https://renseignementsfibre.altitudeinfra.fr/eligibilite/dsp/TLA00",
    urlListeOperateur: "https://www.fibre31.fr/le-projet-tres-haut-debit/operateurs/",
    urlPreparation:
      "https://www.fibre31.fr/wp-content/uploads/sites/13/2022/11/Checklist-raccordement.pdf",
    secondaryMarches: [],
  },
  {
    logo: "images/dsp/TCF00.png",
    codeMarche: "TCF00",
    codeReseau: "AI-04CF",
    libelle: "COEUR COTE FLEURIE",
    urlSite: "https://www.coeurcotefleurie-fibre.fr/",
    urlZonesDeploiement:
      "https://www.coeurcotefleurie-fibre.fr/le-projet-tres-haut-debit/deploiement/",
    urlFibreFtth:
      "https://www.coeurcotefleurie-fibre.fr/pourquoi-je-ne-suis-pas-eligible-a-la-fibre/",
    urlFibreSurDemande:
      "https://www.coeurcotefleurie-fibre.fr/pourquoi-je-ne-suis-pas-eligible-a-la-fibre/",
    urlFibreFtte: "https://www.coeurcotefleurie-fibre.fr/la-fibre-pour-les-entreprises/",
    urlChangementAdresse: "https://renseignementsfibre.altitudeinfra.fr/eligibilite/dsp/TCF00",
    urlListeOperateur:
      "https://www.coeurcotefleurie-fibre.fr/le-projet-tres-haut-debit/operateurs/",
    urlPreparation:
      "https://www.coeurcotefleurie-fibre.fr/wp-content/uploads/sites/13/2022/11/Checklist-raccordement.pdf",
    secondaryMarches: [],
  },
  {
    logo: "images/dsp/KAU00.png",
    codeMarche: "KAU00",
    codeReseau: "AI-CDOR",
    libelle: "CORAI",
    urlSite: "https://www.corai-fibre.fr/",
    urlZonesDeploiement: "https://www.corai-fibre.fr/le-projet-tres-haut-debit/deploiement/",
    urlFibreFtth: "https://www.corai-fibre.fr/pourquoi-je-ne-suis-pas-eligible-a-la-fibre/",
    urlFibreSurDemande: "https://www.corai-fibre.fr/pourquoi-je-ne-suis-pas-eligible-a-la-fibre/",
    urlFibreFtte: "https://www.corai-fibre.fr/la-fibre-pour-les-entreprises/",
    urlChangementAdresse: "https://renseignementsfibre.altitudeinfra.fr/eligibilite/dsp/KAU00",
    urlListeOperateur: "https://www.corai-fibre.fr/le-projet-tres-haut-debit/operateurs/",
    urlPreparation:
      "https://www.corai-fibre.fr/wp-content/uploads/sites/13/2022/11/Checklist-raccordement.pdf",
    secondaryMarches: [],
  },
  {
    logo: "images/dsp/MEN00.png",
    codeMarche: "MEN00",
    codeReseau: "AI-DOUB",
    libelle: "DIOPTIC",
    urlSite: "https://www.dioptic-fibre.fr/",
    urlZonesDeploiement: "https://www.dioptic-fibre.fr/le-projet-tres-haut-debit/deploiement/",
    urlFibreFtth: "https://www.dioptic-fibre.fr/pourquoi-je-ne-suis-pas-eligible-a-la-fibre/",
    urlFibreSurDemande: "https://www.dioptic-fibre.fr/pourquoi-je-ne-suis-pas-eligible-a-la-fibre/",
    urlFibreFtte: "https://www.dioptic-fibre.fr/la-fibre-pour-les-entreprises/",
    urlChangementAdresse: "https://renseignementsfibre.altitudeinfra.fr/eligibilite/dsp/MEN00",
    urlListeOperateur: "https://www.dioptic-fibre.fr/le-projet-tres-haut-debit/operateurs/",
    urlPreparation:
      "https://www.dioptic-fibre.fr/wp-content/uploads/sites/13/2022/11/Checklist-raccordement.pdf",
    secondaryMarches: [],
  },
  {
    logo: "images/dsp/TEE00.png",
    codeMarche: "TEE00",
    codeReseau: "AI-0TE2",
    libelle: "EUROP ESSONNE",
    urlSite: "https://www.europessonne-fibre.fr",
    urlZonesDeploiement: "#",
    urlFibreFtth: "https://www.europessonne-fibre.fr/pourquoi-je-ne-suis-pas-eligible-a-la-fibre/",
    urlFibreSurDemande:
      "https://www.europessonne-fibre.fr/pourquoi-je-ne-suis-pas-eligible-a-la-fibre/",
    urlFibreFtte: "https://www.europessonne-fibre.fr/la-fibre-pour-les-entreprises/",
    urlChangementAdresse: "https://renseignementsfibre.altitudeinfra.fr/eligibilite/dsp/TEE00",
    urlListeOperateur: "https://www.europessonne-fibre.fr/le-projet-tres-haut-debit/operateurs/",
    urlPreparation:
      "https://www.europessonne-fibre.fr/wp-content/uploads/sites/13/2022/11/Checklist-raccordement.pdf",
    secondaryMarches: [],
  },
  {
    logo: "images/dsp/TNA00.png",
    codeMarche: "TNA00",
    codeReseau: "AI-0GNY",
    libelle: "GRAND NANCY",
    urlSite: "https://www.grandnancy-fibre.fr/",
    urlZonesDeploiement: "https://www.grandnancy-fibre.fr/le-projet-tres-haut-debit/deploiement/",
    urlFibreFtth: "https://www.grandnancy-fibre.fr/pourquoi-je-ne-suis-pas-eligible-a-la-fibre/",
    urlFibreSurDemande:
      "https://www.grandnancy-fibre.fr/pourquoi-je-ne-suis-pas-eligible-a-la-fibre/",
    urlFibreFtte: "https://www.grandnancy-fibre.fr/la-fibre-pour-les-entreprises/",
    urlChangementAdresse: "https://renseignementsfibre.altitudeinfra.fr/eligibilite/dsp/TNA00",
    urlListeOperateur: "https://www.grandnancy-fibre.fr/le-projet-tres-haut-debit/operateurs/",
    urlPreparation:
      "https://www.grandnancy-fibre.fr/wp-content/uploads/sites/13/2022/11/Checklist-raccordement.pdf",
    secondaryMarches: [],
  },
  {
    logo: "images/dsp/OEN00.png",
    codeMarche: "OEN00",
    codeReseau: "AI-NIED",
    libelle: "OXYGENE",
    urlSite: "https://www.oxygene-fibre.fr/",
    urlZonesDeploiement: "https://www.oxygene-fibre.fr/deploiement/",
    urlFibreFtth: "https://www.oxygene-fibre.fr/pourquoi-je-ne-suis-pas-eligible-a-la-fibre/",
    urlFibreSurDemande: "https://www.oxygene-fibre.fr/pourquoi-je-ne-suis-pas-eligible-a-la-fibre/",
    urlFibreFtte: "https://www.oxygene-fibre.fr/la-fibre-pour-les-entreprises/",
    urlChangementAdresse: "https://renseignementsfibre.altitudeinfra.fr/eligibilite/dsp/OEN00",
    urlListeOperateur: "https://www.oxygene-fibre.fr/le-projet-tres-haut-debit/operateurs/",
    urlPreparation:
      "https://www.oxygene-fibre.fr/wp-content/uploads/sites/13/2022/11/Checklist-raccordement.pdf",
    secondaryMarches: [],
  },
  {
    logo: "images/dsp/DAU00.png",
    codeMarche: "DAU00",
    codeReseau: "AI-LAND",
    libelle: "PIXL",
    urlSite: "https://www.pixl-fibre.fr/",
    urlZonesDeploiement: "https://www.pixl-fibre.fr/deploiement/",
    urlFibreFtth: "https://www.pixl-fibre.fr/pourquoi-je-ne-suis-pas-eligible-a-la-fibre/",
    urlFibreSurDemande: "https://www.pixl-fibre.fr/pourquoi-je-ne-suis-pas-eligible-a-la-fibre/",
    urlFibreFtte: "https://www.pixl-fibre.fr/la-fibre-pour-les-entreprises/",
    urlChangementAdresse: "https://renseignementsfibre.altitudeinfra.fr/eligibilite/dsp/DAU00",
    urlListeOperateur: "https://www.pixl-fibre.fr/le-projet-tres-haut-debit/operateurs/",
    urlPreparation:
      "https://www.pixl-fibre.fr/wp-content/uploads/sites/13/2022/11/Checklist-raccordement.pdf",
    secondaryMarches: [],
  },
  {
    logo: "images/dsp/RES00.png",
    codeMarche: "RES00",
    codeReseau: "AI-RESO",
    libelle: "RESOPTIC",
    urlSite: "https://www.resoptic.fr/",
    urlZonesDeploiement: "https://www.resoptic.fr/deploiement/",
    urlFibreFtth: "https://www.resoptic.fr/pourquoi-je-ne-suis-pas-eligible-a-la-fibre/",
    urlFibreSurDemande: "https://www.resoptic.fr/pourquoi-je-ne-suis-pas-eligible-a-la-fibre/",
    urlFibreFtte: "https://www.resoptic.fr/la-fibre-pour-les-entreprises/",
    urlChangementAdresse: "https://renseignementsfibre.altitudeinfra.fr/eligibilite/dsp/RES00",
    urlListeOperateur: "https://www.resoptic.fr/le-projet-tres-haut-debit/operateurs/",
    urlPreparation:
      "https://www.resoptic.fr/wp-content/uploads/sites/13/2022/11/Checklist-raccordement.pdf",
    secondaryMarches: [
      {
        codeMarche: "GLA00",
        codeReseau: "AI-GLCS",
        libelle: "GLAUCOS",
      },
    ],
  },
  {
    logo: "images/dsp/VAN00.png",
    codeMarche: "VAN00",
    codeReseau: "AI-REVA",
    libelle: "REV@",
    urlSite: "https://www.reva-numerique.fr/",
    urlZonesDeploiement: "https://www.reva-numerique.fr/deploiement/",
    urlFibreFtth: "https://www.reva-numerique.fr/pourquoi-je-ne-suis-pas-eligible-a-la-fibre/",
    urlFibreSurDemande:
      "https://www.reva-numerique.fr/pourquoi-je-ne-suis-pas-eligible-a-la-fibre/",
    urlFibreFtte: "https://www.reva-numerique.fr/la-fibre-pour-les-entreprises/",
    urlChangementAdresse: "https://renseignementsfibre.altitudeinfra.fr/eligibilite/dsp/VAN00",
    urlListeOperateur: "https://www.reva-numerique.fr/le-projet-tres-haut-debit/operateurs/",
    urlPreparation:
      "https://www.reva-numerique.fr/wp-content/uploads/sites/13/2022/11/Checklist-raccordement.pdf",
    secondaryMarches: [],
  },
  {
    logo: "images/dsp/SEI00.png",
    codeMarche: "SEI00",
    codeReseau: "AI-SETH",
    libelle: "SEINE ESSONNE THD",
    urlSite: "https://www.seineessonne-fibre.fr/",
    urlZonesDeploiement: "#",
    urlFibreFtth: "https://www.seineessonne-fibre.fr/pourquoi-je-ne-suis-pas-eligible-a-la-fibre/",
    urlFibreSurDemande:
      "https://www.seineessonne-fibre.fr/pourquoi-je-ne-suis-pas-eligible-a-la-fibre/",
    urlFibreFtte: "https://www.seineessonne-fibre.fr/la-fibre-pour-les-entreprises/",
    urlChangementAdresse: "https://renseignementsfibre.altitudeinfra.fr/eligibilite/dsp/SEI00",
    urlListeOperateur: "https://www.seineessonne-fibre.fr/le-projet-tres-haut-debit/operateurs/",
    urlPreparation:
      "https://www.seineessonne-fibre.fr/wp-content/uploads/sites/13/2022/11/Checklist-raccordement.pdf",
    secondaryMarches: [],
  },
  {
    logo: "images/dsp/TSO00.png",
    codeMarche: "TSO00",
    codeReseau: "AI-0TSO",
    libelle: "SOMME",
    urlSite: "https://www.somme-fibre.fr/",
    urlZonesDeploiement: "https://www.somme-fibre.fr/le-projet-tres-haut-debit/deploiement/",
    urlFibreFtth: "https://www.somme-fibre.fr/pourquoi-je-ne-suis-pas-eligible-a-la-fibre/",
    urlFibreSurDemande: "https://www.somme-fibre.fr/pourquoi-je-ne-suis-pas-eligible-a-la-fibre/",
    urlFibreFtte: "https://www.somme-fibre.fr/la-fibre-pour-les-entreprises/",
    urlChangementAdresse: "https://renseignementsfibre.altitudeinfra.fr/eligibilite/dsp/TSO00",
    urlListeOperateur: "https://www.somme-fibre.fr/le-projet-tres-haut-debit/operateurs/",
    urlPreparation:
      "https://www.somme-fibre.fr/wp-content/uploads/sites/13/2022/11/Checklist-raccordement.pdf",
    secondaryMarches: [],
  },
  {
    logo: "images/dsp/T0600.png",
    codeMarche: "T0600",
    codeReseau: "AI-LAFI",
    libelle: "LA FIBRE 06",
    urlSite: "https://www.la-fibre-06.fr/",
    urlZonesDeploiement: "https://www.la-fibre-06.fr/le-projet-tres-haut-debit/deploiement/",
    urlFibreFtth: "https://www.la-fibre-06.fr/pourquoi-je-ne-suis-pas-eligible-a-la-fibre/",
    urlFibreSurDemande: "https://www.la-fibre-06.fr/pourquoi-je-ne-suis-pas-eligible-a-la-fibre/",
    urlFibreFtte: "https://www.la-fibre-06.fr/la-fibre-pour-les-entreprises/",
    urlChangementAdresse: "https://renseignementsfibre.altitudeinfra.fr/eligibilite/dsp/T0600",
    urlListeOperateur: "https://www.la-fibre-06.fr/le-projet-tres-haut-debit/operateurs/",
    urlPreparation:
      "https://www.la-fibre-06.fr/wp-content/uploads/sites/13/2022/11/Checklist-raccordement.pdf",
    secondaryMarches: [],
  },
  {
    logo: "images/dsp/HRA00.png",
    codeMarche: "HRA00",
    codeReseau: "AI-NU66",
    libelle: "NUMERIQUE 66",
    urlSite: "https://www.numerique66.fr/",
    urlZonesDeploiement: "https://www.numerique66.fr/le-projet-tres-haut-debit/deploiement/",
    urlFibreFtth: "https://www.numerique66.fr/pourquoi-je-ne-suis-pas-eligible-a-la-fibre/",
    urlFibreSurDemande: "https://www.numerique66.fr/pourquoi-je-ne-suis-pas-eligible-a-la-fibre/",
    urlFibreFtte: "https://www.numerique66.fr/la-fibre-pour-les-entreprises/",
    urlChangementAdresse: "https://renseignementsfibre.altitudeinfra.fr/eligibilite/dsp/HRA00",
    urlListeOperateur: "https://www.numerique66.fr/le-projet-tres-haut-debit/operateurs/",
    urlPreparation:
      "https://www.numerique66.fr/wp-content/uploads/sites/13/2022/11/Checklist-raccordement.pdf",
    secondaryMarches: [],
  },
  {
    logo: "images/dsp/URN00.png",
    codeMarche: "URN00",
    codeReseau: "AI-YCON",
    libelle: "YCONIK",
    urlSite: "https://www.yconik-fibre.fr/",
    urlZonesDeploiement: "https://www.yconik-fibre.fr/le-projet-tres-haut-debit/deploiement/",
    urlFibreFtth: "https://www.yconik-fibre.fr/pourquoi-je-ne-suis-pas-eligible-a-la-fibre/",
    urlFibreSurDemande: "https://www.yconik-fibre.fr/pourquoi-je-ne-suis-pas-eligible-a-la-fibre/",
    urlFibreFtte: "https://www.yconik-fibre.fr/la-fibre-pour-les-entreprises/",
    urlChangementAdresse: "https://renseignementsfibre.altitudeinfra.fr/eligibilite/dsp/URN00",
    urlListeOperateur: "https://www.yconik-fibre.fr/le-projet-tres-haut-debit/operateurs/",
    urlPreparation:
      "https://www.yconik-fibre.fr/wp-content/uploads/sites/13/2022/11/Checklist-raccordement.pdf",
    secondaryMarches: [],
  },
  {
    logo: "images/dsp/KIT00.png",
    codeMarche: "KIT00",
    codeReseau: "AI-AUDE",
    libelle: "EMERAUDE THD",
    codeCouleur: "#a8c813",
    urlSite: "https://www.emeraudethd.fr/",
    urlZonesDeploiement: "https://www.emeraudethd.fr/le-projet-tres-haut-debit/deploiement/",
    urlFibreFtth: "https://www.emeraudethd.fr/pourquoi-je-ne-suis-pas-eligible-a-la-fibre/",
    urlFibreSurDemande: "https://www.emeraudethd.fr/pourquoi-je-ne-suis-pas-eligible-a-la-fibre/",
    urlFibreFtte: "https://www.emeraudethd.fr/la-fibre-pour-les-entreprises/",
    urlChangementAdresse: "https://renseignementsfibre.altitudeinfra.fr/eligibilite/dsp/KIT00",
    urlListeOperateur: "https://www.emeraudethd.fr/le-projet-tres-haut-debit/operateurs/",
    urlPreparation:
      "https://www.emeraudethd.fr/wp-content/uploads/sites/13/2022/11/Checklist-raccordement.pdf",
    secondaryMarches: [],
  },
  {
    logo: "images/dsp/TCA00.png",
    codeMarche: "TCA00",
    codeReseau: "AI-0TCA",
    libelle: "CALVADOS",
    urlSite: "https://www.fibre-calvados.fr/",
    urlZonesDeploiement: "https://www.fibre-calvados.fr/le-projet-tres-haut-debit/deploiement/",
    urlFibreFtth: "https://www.fibre-calvados.fr/pourquoi-je-ne-suis-pas-eligible-a-la-fibre/",
    urlFibreSurDemande:
      "https://www.fibre-calvados.fr/pourquoi-je-ne-suis-pas-eligible-a-la-fibre/",
    urlFibreFtte: "https://www.fibre-calvados.fr/la-fibre-pour-les-entreprises/",
    urlChangementAdresse: "https://renseignementsfibre.altitudeinfra.fr/eligibilite/dsp/TCA00",
    urlListeOperateur: "https://www.fibre-calvados.fr/le-projet-tres-haut-debit/operateurs/",
    urlPreparation:
      "https://www.fibre-calvados.fr/wp-content/uploads/sites/13/2022/11/Checklist-raccordement.pdf",
    secondaryMarches: [],
  },
  {
    logo: "images/dsp/DUN00.png",
    codeMarche: "DUN00",
    codeReseau: "AI-BART",
    libelle: "DGL NETWORK",
    urlSite: "https://www.dunkerquegrandlittoral-fibre.fr/",
    urlZonesDeploiement: "#",
    urlFibreFtth:
      "https://www.dunkerquegrandlittoral-fibre.fr/pourquoi-je-ne-suis-pas-eligible-a-la-fibre/",
    urlFibreSurDemande:
      "https://www.dunkerquegrandlittoral-fibre.fr/pourquoi-je-ne-suis-pas-eligible-a-la-fibre/",
    urlFibreFtte: "https://www.dunkerquegrandlittoral-fibre.fr/la-fibre-pour-les-entreprises/",
    urlChangementAdresse: "https://renseignementsfibre.altitudeinfra.fr/eligibilite/dsp/DUN00",
    urlListeOperateur:
      "https://www.dunkerquegrandlittoral-fibre.fr/le-projet-tres-haut-debit/operateurs/",
    urlPreparation:
      "https://www.dunkerquegrandlittoral-fibre.fr/wp-content/uploads/sites/13/2022/11/Checklist-raccordement.pdf",
    secondaryMarches: [],
  },
  {
    logo: "images/dsp/THS00.png",
    codeMarche: "THS00",
    codeReseau: "AI-0THS",
    libelle: "HAUTE SAVOIE",
    urlSite: "https://www.hautesavoie-fibre.fr/",
    urlZonesDeploiement: "https://www.hautesavoie-fibre.fr/le-projet-tres-haut-debit/deploiement/",
    urlFibreFtth: "https://www.hautesavoie-fibre.fr/pourquoi-je-ne-suis-pas-eligible-a-la-fibre/",
    urlFibreSurDemande:
      "https://www.hautesavoie-fibre.fr/pourquoi-je-ne-suis-pas-eligible-a-la-fibre/",
    urlFibreFtte: "https://www.hautesavoie-fibre.fr/la-fibre-pour-les-entreprises/",
    urlChangementAdresse: "https://renseignementsfibre.altitudeinfra.fr/eligibilite/dsp/THS00",
    urlListeOperateur: "https://www.hautesavoie-fibre.fr/le-projet-tres-haut-debit/operateurs/",
    urlPreparation:
      "https://www.hautesavoie-fibre.fr/wp-content/uploads/sites/13/2022/11/Checklist-raccordement.pdf",
    secondaryMarches: [],
  },
  {
    logo: "images/dsp/TSE00.png",
    codeMarche: "TSE00",
    codeReseau: "AI-0SEQ",
    libelle: "SEQUANTIC",
    urlSite: "https://www.coeurdefibre.fr/eligibilite/",
    urlZonesDeploiement: "#",
    urlFibreFtth: "https://www.coeurdefibre.fr/pourquoi-je-ne-suis-pas-eligible-a-la-fibre/",
    urlFibreSurDemande: "https://www.coeurdefibre.fr/pourquoi-je-ne-suis-pas-eligible-a-la-fibre/",
    urlFibreFtte: "https://www.coeurdefibre.fr/la-fibre-pour-les-entreprises/",
    urlChangementAdresse: "https://renseignementsfibre.altitudeinfra.fr/eligibilite/dsp/TSE00",
    urlListeOperateur: "https://www.coeurdefibre.fr/le-projet-tres-haut-debit/operateurs/",
    urlPreparation:
      "https://www.coeurdefibre.fr/wp-content/uploads/sites/13/2022/11/Checklist-raccordement.pdf",
    secondaryMarches: [],
  },
  {
    logo: "images/dsp/D0200.png",
    codeMarche: "D0200",
    codeReseau: "AI-GRAV",
    libelle: "GRAVELINES",
    urlSite: "https://www.gravelines-fibre.fr/",
    urlZonesDeploiement: "#",
    urlFibreFtth: "https://www.gravelines-fibre.fr/pourquoi-je-ne-suis-pas-eligible-a-la-fibre/",
    urlFibreSurDemande:
      "https://www.gravelines-fibre.fr/pourquoi-je-ne-suis-pas-eligible-a-la-fibre/",
    urlFibreFtte: "https://www.gravelines-fibre.fr/la-fibre-pour-les-entreprises/",
    urlChangementAdresse: "#",
    urlListeOperateur:
      "https://www.gravelines-fibre.fr/le-projet-tres-haut-debit/operateurs/operateurs-particuliers/",
    urlPreparation: "#",
    secondaryMarches: [],
  },
  /*
  {
    logo: "images/dsp/LOS00.png",
    codeMarche: "LOS00",
    codeReseau: "AI-LOSA",
    libelle: "LOSANGE",
    urlSite: "",
    urlZonesDeploiement: "#",
    urlFibreFtth: "",
    urlFibreSurDemande: "",
    urlFibreFtte: "",
    urlChangementAdresse: "",
    urlListeOperateur: "",
    urlPreparation: "",
    secondaryMarches: [],
  },
  {
    logo: "images/dsp/NGR00.png",
    codeMarche: "NGR00",
    codeReseau: "AI-GR12",
    libelle: "NET GRAND RODEZ",
    urlSite: "",
    urlZonesDeploiement: "#",
    urlFibreFtth: "",
    urlFibreSurDemande: "",
    urlFibreFtte: "",
    urlChangementAdresse: "",
    urlListeOperateur: "",
    urlPreparation: "",
    secondaryMarches: [],
  },
  {
    logo: "images/dsp/ROS00.png",
    codeMarche: "ROS00",
    codeReseau: "AI-ROSA",
    libelle: "ROSACE",
    urlSite: "",
    urlZonesDeploiement: "#",
    urlFibreFtth: "",
    urlFibreSurDemande: "",
    urlFibreFtte: "",
    urlChangementAdresse: "",
    urlListeOperateur: "",
    urlPreparation: "",
    secondaryMarches: [],
  },
  {
    logo: "images/dsp/T8300.png",
    codeMarche: "T8300",
    codeReseau: "AI-TD83",
    libelle: "THD 83",
    urlSite: "",
    urlZonesDeploiement: "#",
    urlFibreFtth: "",
    urlFibreSurDemande: "",
    urlFibreFtte: "",
    urlChangementAdresse: "",
    urlListeOperateur: "",
    urlPreparation: "",
    secondaryMarches: [],
  },
  {
    logo: "images/dsp/VNU00.png",
    codeMarche: "VNU00",
    codeReseau: "AI-VENU",
    libelle: "Vendée Numérique",
    urlSite: "https://www.vendeenumerique.fr/",
    urlZonesDeploiement: "https://www.vendeenumerique.fr/vendee-numerique/les-projets/",
    urlFibreFtth: "https://www.vendeenumerique.fr/vendee-numerique/les-projets/",
    urlFibreSurDemande: "https://www.vendeenumerique.fr/raccordement-a-la-demande",
    urlFibreFtte: "https://www.vendeenumerique.fr/la-fibre/la-fibre-ftte/",
    urlChangementAdresse: "https://renseignementsfibre.altitudeinfra.fr/eligibilite/dsp/VEN00",
    urlListeOperateur: "https://www.vendeenumerique.fr/les-operateurs/les-operateurs-ftth/",
    urlPreparation: "https://www.vendeenumerique.fr/vendee-numerique/les-projets/",
    secondaryMarches: [],
  },
  */
];

export const zaAmiiVendeeInfo = [
  {
    name: "LA ROCHE SUR YON",
    logoSrc: LOGO_ROCHE,
    title: "Agglomération de la Roche sur Yon",
    location: "l’agglomération de la Roche sur Yon",
    infoUrl: "https://www.larochesuryon.fr/services-infos-pratiques/tres-haut-debit/",
    infoName: "www.larochesuryon.fr",
  },
  {
    name: "MAREUIL SUR LAY DISSAIS",
    logoSrc: LOGO_MAREUIL,
    title: "Zone de Mareuil sur Lay",
    location: "la commune de Mareuil sur Lay",
    infoUrl:
      "https://www.vendeenumerique.fr/qui-sommes-nous/GIP/le-perimetre-d-intervention-de-vendee-numerique/",
    infoName: "www.vendeenumerique.fr",
  },
  {
    name: "SABLES D OLONNE",
    logoSrc: LOGO_SABLES,
    title: "Agglomération des Sables d'Olonne",
    location: "l’agglomération des Sables d’Olonne",
    infoUrl:
      "https://www.lsoagglo.fr/vivreauxolonnes/amenagement-dechets-environnement-habitat-urbanisme/amenagement/fibre-optique/",
    infoName: "www.lsoagglo.fr",
  },
];

export const removeInformationsDeploiementDsp = ["AI-MNUM"];
